import script from "./FloatInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatInput.vue?vue&type=script&setup=true&lang=js"

import "./FloatInput.vue?vue&type=style&index=0&id=5a160798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a160798"]])

export default __exports__